import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { SelfAttestedIncome } from "types/landlord/reports";
import { ChevronDown, ChevronUp } from "untitledui-js-base";
import { formatToCurrency } from "utils/currency";
import { getSelfAttestedIncomeSourceInfo } from "../VerifiedIncomeSourcesTableExpander/utils";

type selfAttestedIncomeColumnType =
  SelfAttestedIncome["income_sources"][number];

const columnHelper = createColumnHelper<selfAttestedIncomeColumnType>();

export const selfAttestedIncomeSourcesColumns: ColumnDef<
  selfAttestedIncomeColumnType,
  any
>[] = [
  columnHelper.accessor("income_source", {
    header: "Income source",
    cell: ({ row }) => {
      const data = getSelfAttestedIncomeSourceInfo(row.original);
      const Icon = data.icon;
      return (
        <div className="flex gap-4 items-center">
          <Icon className="stroke-content-400" />
          <div className="space-y-1">
            <p className="text-content-1000 font-medium">{data.title}</p>
            <p className="text-content-400 font-normal">{data.subtitle}</p>
          </div>
        </div>
      );
    }
  }),
  columnHelper.accessor("employment", {
    header: "Date range",
    cell: ({ row }) => {
      const data = row.original;
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      const currentTypeOfSelfAttested = row.original?.income_source
        .toLowerCase()
        .replaceAll(/[ -]+/g, "_");
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      const endDate = data?.[currentTypeOfSelfAttested]?.end_date
        ? moment(data[currentTypeOfSelfAttested]?.end_date).format(
            "MMM DD, YYYY"
          )
        : "Present";

      if (currentTypeOfSelfAttested === "offer_letter")
        return (
          <p className="text-left">
            {
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              data
                ? `Start date: ${moment(data[currentTypeOfSelfAttested]?.start_date).format("MMM YYYY")}`
                : "-"
            }
          </p>
        );

      return (
        <p className="text-left">
          {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            data
              ? `${moment(data[currentTypeOfSelfAttested]?.start_date).format("MMM DD, YYYY")} - ${endDate}`
              : "-"
          }
        </p>
      );
    }
  }),
  columnHelper.accessor("monthly_income", {
    id: "right-align",
    header: "Gross monthly",
    cell: ({ getValue }) => {
      const data = getValue();
      return (
        <p className="font-medium text-end">
          {formatToCurrency({ cents: data?.cents, currency: data?.currency })}
        </p>
      );
    }
  }),
  columnHelper.accessor("expander" as any, {
    header: "",
    size: 64,
    cell: ({ row }) => {
      return (
        row.getCanExpand() && (
          <IconButton
            Icon={row.getIsExpanded() ? ChevronUp : ChevronDown}
            onClick={() => row.toggleExpanded()}
            size={IconButtonSize.SM}
            className="!stroke-content-300"
            variant={IconButtonVariant.BASE}
          />
        )
      );
    }
  })
];
